module.exports = __webpack_public_path__ + "media/images/ogp-465f92e03583e5d4bd38271168eb276b.jpg";